import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "dictate-additions",
  courseId: "reports-from-audio",
  order: 7,
  title: "Dictate additions",
  subtitle: "Add to an existing report",
  summary:
    "You left something out of the recording. Add it by voice, either by answering the suggestions with a recording or by dictating straight into the editor at the cursor.",
  learn: [
    "Use Address Suggestions to fill gaps with a recording or upload",
    "Use Transcribe Audio to dictate at the cursor",
    "Choose between Enhanced Dictation and Pure Dictation",
  ],
  minutes: 4,
  sceneId: "dictate-additions",
  tourId: "dictate-additions",
  releasedAt: "2026-04-09T00:00:00.000Z",
  body: [
    {
      type: "paragraph",
      text: "You rarely get everything into the first recording. Rather than typing the rest, talk. The two flows do different things: **Address Suggestions** puts facts into the existing narrative, and **Transcribe Audio** adds new text where your cursor is.",
    },
    { type: "heading", text: "Answer the suggestions" },
    {
      type: "steps",
      items: [
        "Open the **Suggestions** tab and click **Address Suggestions**.",
        "Choose **Record Audio** or **Upload Audio**.",
        "Speak to the open items, for example: \"I arrived at 2214 hours, the subject left northbound on foot.\"",
        "Click **Apply to Report** (recording) or submit the upload.",
        "Review the result under \"Review Addition\" or \"Review Rewrite\" and compare Original and Rewritten.",
        "Keep the change, or click **Discard**. \"Stop reviewing\" exits the review.",
      ],
    },
    {
      type: "paragraph",
      text: "The AI works your answers into the right paragraphs and may rewrite nearby sentences for flow, which is why the review step is there.",
    },
    { type: "heading", text: "Dictate at the cursor" },
    {
      type: "steps",
      items: [
        "Click where you want the text to go.",
        "Click **Transcribe Audio** in the editor toolbar.",
        "Pick your microphone and, if you want, a template.",
        "Choose **Enhanced Dictation** or **Pure Dictation**.",
        "Use Pause, Resume, and Cancel as needed, then Finish recording. The text is inserted at the cursor.",
      ],
    },
    {
      type: "bullets",
      items: [
        "**Enhanced Dictation** cleans up and formats what you say in your report style. It applies your Report Preferences (perspective, time format, rank).",
        "**Pure Dictation** is a near-verbatim transcript with light punctuation that you edit yourself. It does not apply your Report Preferences.",
      ],
    },
    {
      type: "callout",
      tone: "tip",
      title: "Which flow?",
      text: "Use Address Suggestions for facts that belong somewhere specific in the existing narrative. Use Transcribe Audio for a new paragraph, such as a supplemental, a follow-up interview, or a second scene.",
    },
    {
      type: "paragraph",
      text: "If you changed enough that the whole report should be redrafted, read \"Regenerate\".",
    },
  ],
  related: ["review-the-draft", "regenerate-the-narrative"],
};

export default lesson;
